const schemaUploadTemplate = {
  type: 'object',
  properties: {
    ulploadType: {
      type: 'string',
      description:
        'Definition of the upload type. Each Upload type has a specific upload flow and required Asset creations.',
    },
    displayName: {
      type: 'string',
      description: 'Display name of the upload type. This is the name that will be displayed to the end user.',
    },
    collectionAssetType: {
      type: 'string',
      description:
        'Asset type of the collection asset that will be created when a new upload is initiated. This asset will be the seen as the parent of the file set assets that are created during the upload process.',
    },
    collectionAssetDisplayNameProperty: {
      type: 'string',
      description:
        'Property of the collection asset that will be used as the display name of the collection asset. This is the name that will be displayed to the end user. This property should be a property of the collection asset type. ',
    },
    collectionDataContext: {
      type: 'string',
      description: 'Property key of the collection asset that will be used as identifier to fetch the data_context ',
    },
    fileSetAssetType: {
      type: 'string',
      description:
        'Asset type of the file set assets that will be created when a new upload is initiated. These assets will be the children of the collection asset.',
    },
    fileSetAssetDataContext: {
      type: 'string',
      description: 'Property key of the File set assets that will be used as identifier to fetch the data_context ',
    },
    collectionMetadata: {
      type: 'array',
      description:
        'Definition of the metadata that will be collected for the collection asset. This metadata will be collected during the upload process and used to create the collection asset.',
      items: {
        type: 'object',
        properties: {
          id: {
            type: 'string',
            description:
              'Identifier of the MetaData. This is the key that will be used to store this info as property for an asset.',
          },
          name: {
            type: 'string',
            description:
              'This is how the metadata will be displayed to the end user. This should be a human readable name that describes the metadata.',
          },
          dataType: {
            type: 'string',
            description:
              'The type of the metadata. This will be used to validate the input of the user. The current possible values are: "string"',
          },
          required: {
            type: 'boolean',
            description:
              'Boolean value that indicates if the metadata property is required. If true, the user will not be able to start the upload process without providing a value for this metadata.',
          },
        },
        required: ['id', 'name', 'dataType', 'required'],
      },
    },
    fileSetMetadata: {
      type: 'array',
      description:
        'Definition of the metadata that will be collected for the File assets. This metadata will be collected during the upload process and used to create the File asset.',
      items: {
        type: 'object',
        properties: {
          id: {
            type: 'string',
            description:
              'Identifier of the MetaData. This is the key that will be used to store this info as property for an asset.',
          },
          name: {
            type: 'string',
            description:
              'This is how the metadata will be displayed to the end user. This should be a human readable name that describes the metadata.',
          },
          dataType: {
            type: 'string',
            description:
              'The type of the metadata. This will be used to validate the input of the user. The current possible values are: "string"',
          },
          required: {
            type: 'boolean',
            description:
              'Boolean value that indicates if the metadata property is required. If true, the user will not be able to start the upload process without providing a value for this metadata.',
          },
          width: {
            type: 'number',
            description:
              'Width of the metadata property. This will be used to visualize the file in the overview table.',
          },
        },
        required: ['id', 'name', 'dataType', 'required'],
      },
    },
    filePatterns: {
      type: 'array',
      description:
        'Definition of the file patterns that will be used to validate the files that are uploaded. The file patterns will be used to validate the file names of the files that are uploaded.',
      items: {
        type: 'object',
        properties: {
          PropertyId: {
            type: 'string',
            description:
              'Identifier of the MetaData. This is the key that will be used to store this info as property for an asset. This also defines which file metadata should be assigned during the file upload process.',
          },
          patterns: {
            type: 'array',
            description:
              'A list of file patterns that will be used to validate the file names of the files that are uploaded.',
            items: {
              type: 'string',
              description:
                'A regular expression that will be used to validate the file names of the files that are uploaded.',
            },
          },
        },
        required: ['type', 'patterns'],
      },
    },
  },

  required: [
    'uploadType',
    'displayName',
    'collectionAssetType',
    'collectionAssetDisplayNameProperty',
    'fileSetAssetType',
    'collectionMetadata',
    'fileSetMetadata',
    'filePatterns',
  ],
  additionalProperties: false,
};

export default schemaUploadTemplate;
